/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalDocumentExtraction
 */
export interface PalDocumentExtraction {
    /**
     * 
     * @type {string}
     * @memberof PalDocumentExtraction
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalDocumentExtraction
     */
    status: PalDocumentExtractionStatusEnum;
}


/**
 * @export
 */
export const PalDocumentExtractionStatusEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Completed: 'completed'
} as const;
export type PalDocumentExtractionStatusEnum = typeof PalDocumentExtractionStatusEnum[keyof typeof PalDocumentExtractionStatusEnum];


/**
 * Check if a given object implements the PalDocumentExtraction interface.
 */
export function instanceOfPalDocumentExtraction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function PalDocumentExtractionFromJSON(json: any): PalDocumentExtraction {
    return PalDocumentExtractionFromJSONTyped(json, false);
}

export function PalDocumentExtractionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalDocumentExtraction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
    };
}

export function PalDocumentExtractionToJSON(value?: PalDocumentExtraction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
    };
}

